export interface FirebaseCredentials {
  accessToken: string
  expiresIn: number
  uuid: string
}

export enum FirebaseProject {
  GESTAO = 'GESTAO',
}

export function createFirebaseCredentials (): FirebaseCredentials {
  return {
    accessToken: '',
    expiresIn: 0,
    uuid: ''
  }
}
